var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-12",attrs:{"fluid":""}},[_c('custom-toolbar'),_c('v-row',{staticClass:"padded-text pt-5",attrs:{"row":"","justify":"center"}},[_c('h3',{staticClass:"display-2"},[_vm._v("The page you requested does not exist. :(")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }